import { faCirclePlus, faShareAlt } from "@fortawesome/free-solid-svg-icons";
import { Button, Col, Container, Row } from "reactstrap";
import { MultiSelectableList } from "./MultiSelectableList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Fab } from "../Fab";
import { CyPlaylistIndex } from "../../../playlists/CyPlaylistIndex";
import { HeaderButtonBurger } from "../../header/HeaderButtonBurger";
import { Link } from "react-router-dom";
import { ReactNode } from "react";

interface DataInterface {
  identifier: string;
  name: string;
  age: number;
}

export function DemoMultiSelectableList() {
  const { t } = useTranslation();
  const headerColumn = (
    <>
      <Col>Name</Col>
      <Col>Age</Col>
    </>
  );

  const headerFirstRow = (
    <>
      <Row className="gy-2 pt-2">
        <Col className="col-auto d-flex">
          <div className="d-flex with-left-column">
            <HeaderButtonBurger setIsMainMenuOpen={() => {}} />
          </div>
        </Col>
        <Col className="d-flex col-8 col-md align-items-center">
          <h3 className="mb-0 ps-0">Demo Title</h3>
        </Col>
        <Col className="col-auto d-flex justify-content-end align-items-start">
          <Button tag={Link} color="primary" to={"foo"}>
            <FontAwesomeIcon icon={faShareAlt} className="pe-2" />
            Share
          </Button>
        </Col>
      </Row>
    </>
  );

  const data: readonly DataInterface[] = [
    {
      identifier: "1",
      name: "John",
      age: 23,
    },
    {
      identifier: "2",
      name: "Doe",
      age: 33,
    },
    {
      identifier: "3",
      name: "Alice",
      age: 29,
    },
    {
      identifier: "4",
      name: "Bob",
      age: 45,
    },
    {
      identifier: "5",
      name: "Charlie",
      age: 22,
    },
    {
      identifier: "6",
      name: "David",
      age: 31,
    },
    {
      identifier: "7",
      name: "Eve",
      age: 27,
    },
    {
      identifier: "8",
      name: "Frank",
      age: 36,
    },
    {
      identifier: "9",
      name: "Grace",
      age: 24,
    },
    {
      identifier: "10",
      name: "Hank",
      age: 40,
    },
    {
      identifier: "11",
      name: "Ivy",
      age: 28,
    },
    {
      identifier: "12",
      name: "Jack",
      age: 35,
    },
    {
      identifier: "13",
      name: "Karen",
      age: 30,
    },
    {
      identifier: "14",
      name: "Leo",
      age: 26,
    },
    {
      identifier: "15",
      name: "Mona",
      age: 32,
    },
    {
      identifier: "16",
      name: "Nina",
      age: 21,
    },
    {
      identifier: "17",
      name: "Oscar",
      age: 34,
    },
    {
      identifier: "18",
      name: "Paul",
      age: 38,
    },
    {
      identifier: "19",
      name: "Quinn",
      age: 25,
    },
    {
      identifier: "20",
      name: "Rick",
      age: 37,
    },
    {
      identifier: "21",
      name: "Sara",
      age: 23,
    },
    {
      identifier: "22",
      name: "Tom",
      age: 39,
    },
    {
      identifier: "23",
      name: "Uma",
      age: 28,
    },
    {
      identifier: "24",
      name: "Vince",
      age: 32,
    },
    {
      identifier: "25",
      name: "Wendy",
      age: 27,
    },
    {
      identifier: "26",
      name: "Xander",
      age: 35,
    },
    {
      identifier: "27",
      name: "Yara",
      age: 24,
    },
    {
      identifier: "28",
      name: "Zane",
      age: 31,
    },
    {
      identifier: "29",
      name: "Amy",
      age: 29,
    },
    {
      identifier: "30",
      name: "Brian",
      age: 33,
    },
    {
      identifier: "31",
      name: "Cathy",
      age: 26,
    },
    {
      identifier: "32",
      name: "Derek",
      age: 30,
    },
    {
      identifier: "33",
      name: "Ella",
      age: 22,
    },
    {
      identifier: "34",
      name: "Fred",
      age: 28,
    },
    {
      identifier: "35",
      name: "Gina",
      age: 34,
    },
    {
      identifier: "36",
      name: "Holly",
      age: 25,
    },
    {
      identifier: "37",
      name: "Ian",
      age: 27,
    },
    {
      identifier: "38",
      name: "Jane",
      age: 31,
    },
    {
      identifier: "39",
      name: "Kyle",
      age: 29,
    },
    {
      identifier: "40",
      name: "Liam",
      age: 36,
    },
  ];

  //https://www.developerway.com/posts/react-component-as-prop-the-right-way
  function renderRow(d: DataInterface): ReactNode {
    return (
      <Row>
        <Col xs={12} lg={8}>
          <span className="lead" data-cy={CyPlaylistIndex.PlaylistTitle}>
            {d.name}
          </span>
        </Col>
        <Col lg={2}>
          <span className="d-lg-none">Age: </span>
          {d.age}
        </Col>
      </Row>
    );
  }

  return (
    <>
      <Container fluid={true}>
        <MultiSelectableList
          headerFirstRow={headerFirstRow}
          headerColumns={[headerColumn]}
          data={data}
          renderElement={renderRow}
          keyExtractor={(d) => d.identifier}
          linkBuilder={(d) => `/demo/${d.identifier}`}
        />

        <Fab onClick={() => alert("Fab clicked")} data-cy={"ButtonFab"}>
          <FontAwesomeIcon icon={faCirclePlus} />{" "}
          {t("playlist.index.addPlaylist")}
        </Fab>
      </Container>
    </>
  );
}
